import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-display text-lg font-semibold text-gray-800 mb-4">Egg Time On</h3>
            <p className="text-gray-600 mb-6">The most convenient online timer for boiling perfect eggs every time. Customize your settings and enjoy perfect eggs.</p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary-600 transition-colors">
                <Facebook className="h-5 w-5" />
                <span className="sr-only">Facebook</span>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary-600 transition-colors">
                <Twitter className="h-5 w-5" />
                <span className="sr-only">Twitter</span>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary-600 transition-colors">
                <Instagram className="h-5 w-5" />
                <span className="sr-only">Instagram</span>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary-600 transition-colors">
                <Youtube className="h-5 w-5" />
                <span className="sr-only">YouTube</span>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold text-gray-800 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-600 hover:text-primary-600 transition-colors"
                  onClick={handleHomeClick}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link to="/recipes" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary-600 transition-colors">Egg Recipes</Link>
              </li>
              <li>
                <Link to="/contact" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary-600 transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold text-gray-800 mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary-600 transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary-600 transition-colors">Terms of Use</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-gray-500 text-sm">
          <p>&copy; {currentYear} Egg Time On. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;